import axiosApiInstance from '@/api/axios'
import { AxiosResponse } from 'axios'
import {
  RoleUserResponseModel,
  UserEmailCompleteValidationModel,
  UserModel,
} from './models/UserModel'
import { ACCOUNT_ENDPOINTS } from './api/api'

class AccountService {
  async getCurrentUser(): Promise<UserModel> {
    const res = await axiosApiInstance.get(`/Users/Current`)
    return res.data
  }

  async updateCurrentUser(data: UserModel): Promise<UserModel> {
    const res = await axiosApiInstance.patch(`/Users/Current`, data)
    return res.data
  }

  async userEmailCompleteValidation(
    data: UserEmailCompleteValidationModel,
  ): Promise<AxiosResponse<UserModel>> {
    const res = await axiosApiInstance.post(
      `/Users/Email/CompleteValidation`,
      data,
    )
    return res.data
  }

  async getUserRole(userId: string): Promise<RoleUserResponseModel> {
    const res = await axiosApiInstance.get(ACCOUNT_ENDPOINTS.USER_ROLE, {
      params: {
        ['_userId']: userId,
      },
    })
    return res.data
  }
}

export default new AccountService()
